import { Tags } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerLabelsSpec: ModuleSpec = {
  id: "customer-labels",
  icon: Tags,
  i18n: {
    namespace: "modules",
    titleKey: "customer-labels.title",
    descriptionKey: "customer-labels.description",
  },
  nav: {
    path: "/customers/labels",
    group: "observe",
    order: 40,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Manage customer labels and tags",
  },
};
